import React from "react";
import "./PartnersLandingAbout.css";

const PartnersLandingAbout = ({
  image = "/img/monterrey-about.png",
  title = "Title to be determined",
  onApplyClick,
}) => {
  return (
    <div className="partners-about container-fluid monterrey-about">
      <div
        className="row w-100 mx-auto partners-about__row"
        style={{ maxWidth: "1246px" }}
      >
        {/* Mobile Image */}
        <div className="col-12 show-mobile px-0">
          <img alt={title} src={image} className="w-100" />
        </div>

        {/* Left Side - Text */}
        <div className="col-12 px-0 col-md-6 partners-about__content features__container">
          <p className="partners-about__title text-uppercase">
            Become a TBM Partner Studio
          </p>

          <div className="row w-100 mx-auto">
            <div className="col-12 mb-md-5 px-0">
              <ol className="partners-about__list">
                <li className="partners-about__list-item">
                  <span className="partners-about__list-title">
                    TBM Certifications
                  </span>
                  <span className="partners-about__list-desc">
                    Completa tu proceso de certificación con TBM y obtén tu
                    certificado oficial.
                  </span>
                  <a
                    href="https://tbmcertifications.com/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="btn btn-primary partners-about__certify-btn mt-2"
                  >
                    Get certified
                    <i className="fas fa-arrow-right ms-2" />
                  </a>
                </li>
                <li className="partners-about__list-item">
                  <span className="partners-about__list-title">
                    Envía tu solicitud para ser TBM Partner Studio
                  </span>
                  <span className="partners-about__list-desc">
                    Llena el formulario con la información del estudio, ciudad,
                    redes y fotos. Importante: debes contar con el espacio y el
                    material/equipo necesario para impartir la experiencia TBM.
                  </span>
                  {onApplyClick && (
                    <button
                      type="button"
                      className="btn btn-sm btn-primary bold px-3 partners-about__certify-btn mt-2"
                      style={{
                        borderRadius: "40px",
                        height: "40px",
                        fontSize: "0.9rem",
                      }}
                      onClick={onApplyClick}
                    >
                      Apply now
                      <i className="fas fa-arrow-right ms-2" />
                    </button>
                  )}
                </li>
                <li className="partners-about__list-item">
                  <span className="partners-about__list-title">
                    Revisión + llamada rápida con el equipo TBM
                  </span>
                  <span className="partners-about__list-desc">
                    Revisamos tu solicitud, validamos alineación con la marca y
                    resolvemos dudas.{" "}
                    <i>
                      TBM se reserva el derecho de seleccionar a sus studios
                      aliados.
                    </i>
                  </span>
                </li>
                <li className="partners-about__list-item">
                  <span className="partners-about__list-title">
                    Validación de calidad (clase muestra o video corto)
                  </span>
                  <span className="partners-about__list-desc">
                    Confirmamos que la experiencia, ejecución y estándar de
                    enseñanza estén alineados a TBM.
                  </span>
                </li>
                <li className="partners-about__list-item">
                  <span className="partners-about__list-title">
                    Aprobación + alta oficial
                  </span>
                  <span className="partners-about__list-desc">
                    Firma del acuerdo, entrega del Partner Kit, asignación de
                    Partner ID y publicación en el directorio de TBM Partner
                    Studios.
                  </span>
                </li>
              </ol>
            </div>
          </div>
        </div>

        {/* Right Side - Image */}
        <div className="col-md-6 hide-mobile ms-auto">
          <img alt={title} src={image} className="mw-100 w-100" />
        </div>
      </div>
    </div>
  );
};

export default PartnersLandingAbout;
